import "./Services.module.css";
import Navigation from "@/reusable_sections/Header";
import Services from "./sections/Services";
import Seo from "./sections/Seo";
import Wartung from "./sections/Wartung";
import Footer from "@/reusable_sections/Footer";
export default function ServicesPage() {
  return <div>
      <Navigation />
      <Services />
      <Seo />
      <Wartung />
      <Footer />
    </div>;
}